// FIX 6 (Task 5) — single source of truth for WhatsApp number normalization.
// Produces an E.164 digit string (no '+', spaces, or duplicated country code),
// e.g. cc "+91" + phone "98765 43210" → "919876543210". Use everywhere:
// leads, travellers, trips and message templates.
export const waNumber = (countryCode = '+91', phone = '') => {
  const c = String(countryCode || '+91').replace(/[^0-9]/g, '') || '91';
  let p = String(phone || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
  if (!p) return '';
  // Dedupe a country code already baked into the phone (length guard avoids
  // mis-stripping a 10-digit number that merely starts with the cc digits).
  if (c && p.length > 10 && p.startsWith(c)) p = p.slice(c.length);
  return `${c}${p}`;
};

// Build a wa.me click-to-chat link with an optional prefilled message.
export const waLink = (countryCode, phone, text = '') => {
  const num = waNumber(countryCode, phone);
  const base = num ? `https://wa.me/${num}` : 'https://wa.me/';
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};
